import Vue from 'vue';

export const onProductView = ({ product, eventId }) => {
    const products = [Vue.$gtm.getProductObject(product)];

    // UA
    Vue.$gtm.push({
        event: 'productView',
        facebookEventID: eventId,
        ecommerce: {
            detail: {
                products: products,
            },
        },
    });

    // GA4
    Vue.$gtm.push({
        event: 'view_item',
        facebookEventID: eventId,
        ecommerce: {
            items: products,
        },
    });
};
